<template>
  <div
    class="b-expansion-panel"
    :class="{ active: isActive }"
  >
    <div
      class="b-expansion-panel-header"
    >
      <div
        class="header-content"
      >
        <div
          class="main-header-content"
          :class="{ 'align-start': divider }"
          @click="handleClick"
        >
          <BIcon
            class="header-icon"
          >
            arrow_drop_down
          </BIcon>
          <slot name="header" />
        </div>
        <div class="additional-header-content">
          <slot name="additional-header-content" />
        </div>
      </div>
      <ElDivider
        v-if="divider"
        class="mb-300 header-divider"
      />
    </div>
    <BSlideUpDown
      class="b-expansion-panel-content"
      :active="isActive"
    >
      <div class="b-expansion-panel-content-inner">
        <slot />
      </div>
    </BSlideUpDown>
  </div>
</template>

<script lang="ts" setup>
import { ref, watch } from 'vue';
type TProps = {
  expand: boolean;
  divider?: boolean;
};

const props = withDefaults(defineProps<TProps>(), {
  divider: false,
});

const isActive = ref(props.expand);
watch(props.expand, (value) => {
  isActive.value = value;
});

const handleClick = () => {
  isActive.value = !isActive.value;
};
</script>

<style lang="scss" scoped>
  .b-expansion-panel {
    &.active > .b-expansion-panel-header {
      .header-icon {
        transform: rotate(0deg);
      }
    }
  }

  .b-expansion-panel-header {
    display: flex;
    align-items: start;
    flex-direction: column;

    .header-icon {
      transition: all 300ms $standard-easing;
      transform: rotate(-90deg);
      font-size: $fontsize-500;
      width: 20px;
    }

    .header-content {
      width: calc(100% - 20px);

      display: flex;
      flex-direction: row;
      align-items: center;
    }

    .main-header-content {
      cursor: pointer;
      width: fit-content;
      display: flex;
      flex-direction: row;
      align-items: center;

      &:hover {
        opacity: .5;
      }

      &.align-start {
        align-items: start;
      }
    }

    .header-divider {
      width: calc(100% - 20px);
      margin-top: 0;
      margin-left: 20px;
    }
  }

  .b-expansion-panel-content {
    padding: 0 0 0 $basespace-400;
  }

  .b-expansion-panel-content-inner {
    padding-top: $basespace-100;
  }
</style>
